
class CommonsService {
  constructor () {
    this.history = null
    this.play = null
  }

  isProd () {
    return process.env.REACT_APP_ENV_NAME === 'prod'
  }

  goToPage (route, forceTravel = false) {
    if (!forceTravel && window.location.href.includes(route)) {
      return
    }
    this.history?.push(route)
  }

  openInNewTab (url) {
    window.open(url, '_blank').focus()
  }

  soundNotification () {
    this.play()
  }

  getQueryParams (param) {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get(param)
  }

  urlIncludesString (string) {
    return this.history?.location.pathname.includes(string)
  }

  getCurrentPath () {
    return this.history?.location.pathname
  }

  isMobile () {
    const media_mobile = window.matchMedia('(max-width: 767px)')
    return media_mobile?.matches
  }

  scrollToTop () {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  scrollToTopOfFeed () {
    document.querySelector('#main-feed-scroll')?.scrollTo({ top: 0, behavior: 'smooth' })
  }

  navigateToInit () {
    if (window.location.pathname === '/') this.scrollToTop()
    else this.history.push('/')
  }

  removeStorageAndRefresh () {
    const items = { ...window.localStorage }
    for (const item in items) {
      if (/CognitoIdentityServiceProvider\..*\./.test(item)) { window.localStorage.removeItem(item) }
    }
    window.location.href = '/'
  }
}

export default new CommonsService()
